import { Injectable } from '@angular/core';
import { createSelector } from '@ngrx/store';
import { PageUiState, SafariReduxPageUiObject, defaultPageUiState } from '@safarilaw-webapp/shared/redux';
import { getSharedFeatureState } from '../../../../redux/state.selector';

@Injectable({ providedIn: 'root' })
export class LpmsServeportPortalEdtPageReduxUiObject extends SafariReduxPageUiObject<PageUiState> {
  // Doing this to prevent the compiler from complaining. We will be getting rid of this default
  // thing but this makes it compile for now
  default = {};

  constructor() {
    const getPageState = createSelector(getSharedFeatureState, state => state.pages.serveportPortalEditPage);
    super('Lpms', 'Serveport Portal Edit', getPageState, defaultPageUiState);
  }
}
